import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from '@tanstack/react-router';
import { TooltipProvider } from '@/components/ui/tooltip';
import { RequireAuth } from '@/components/RequireAuth';
import { router } from '@/lib/router';
import { queryClient } from '@/lib/queryClient';
import { useTheme } from '@/hooks/useTheme';
import './styles/globals.css';

function ThemeBoot({ children }: { children: React.ReactNode }) {
  useTheme();
  return <>{children}</>;
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <TooltipProvider delayDuration={300}>
        <ThemeBoot>
          <RequireAuth>
            <RouterProvider router={router} />
          </RequireAuth>
        </ThemeBoot>
      </TooltipProvider>
    </QueryClientProvider>
  </React.StrictMode>
);
